<template>
  <div class="page-main" style="width: 100%">
    <el-row>
      <el-col :span="22" :offset="1">
        <div style="margin-bottom: 10px" class="menuTag">
          <template v-for="(menu, i) in $store.state.activedMenus">
            <el-tag class="mr-10 a-menu" :class="menu.path === $route.path ? 'activedMenu' : ''" :key="i"
              :closable="i !== 0" @click="handleSelect(menu)" @close="handleClose(menu)">
              {{ menu.name }}
            </el-tag>
          </template>
        </div>
        <div>
          <router-view v-if="_isRouterAlive()"></router-view>
        </div>
      </el-col></el-row>
    <div class="page-fixed" @mouseleave="fixedLayer = false">
      <div v-if="!fixedLayer" class="fixedBtn" @mouseover="fixedLayer = true">
        <el-button type="primary" icon="el-icon-plus" circle></el-button>
      </div>
      <el-row class="fixedLayer" :gutter="20" v-if="fixedLayer">
        <el-col :span="12" align="center">
          <el-button type="text" icon="el-icon-tickets" title="故障单" @click="enterInsideLetter"></el-button>
        </el-col>
        <el-col :span="12" align="center">
          <el-button type="text" icon="el-icon-refresh" @click="reload" title="刷新"></el-button>
        </el-col>
        <!-- 功能未实现，暂时不用 -->
        <!-- <el-col :span="8" align="center">
          <el-button
            type="text"
            icon="el-icon-chat-dot-round"
            title="二维码"
            v-popover:qrCodePopover
          ></el-button>
          <el-popover
            ref="qrCodePopover"
            placement="top"
            width="200"
            trigger="hover"
            content="这里是二维码图片"
          >
          </el-popover>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import Index from "@/components/Index.vue";
import Resource from "@/components/Resource.vue";
import Job from "@/components/Job.vue";
export default {
  name: "page-main",
  components: {
    index: Index,
    resource: Resource,
    job: Job,
  },
  inject: ["isRouterAlive"],
  data() {
    return {
      activeIndex: "1",
      fixedLayer: false,
    };
  },
  methods: {
    _isRouterAlive() {
      return this.isRouterAlive();
    },
    handleSelect(menu) {
      this.$router.push({ path: menu.path });
    },
    handleClose(menu) {
      let activedMenus = this.$store.state.activedMenus;
      this.$store.commit("removeActivedMenu", menu.path);
      this.$router.push({ path: activedMenus[activedMenus.length - 1].path });
    },
    reload() {
      window.location.reload();
    },
    enterInsideLetter() {
      this.$store.commit("addActivedMenu", {
        path: "/insideLetter2",
        name: "故障单",
      });
      this.$router.push({ path: "/insideLetter2" });
    },
  },
  created() { },
  mounted() { },
};
</script>
<style lang="scss">
.page-fixed {
  z-index: 999;
  position: fixed;
  bottom: 0;
  right: 0;

  .fixedBtn {
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .fixedLayer {
    width: 200px;
    padding: 10px;
    // border-top: 1px solid grey;
    // border-left: 1px solid grey;
    // background: rgba(255, 255, 255, 0.1);
    //border-top-left-radius: 15px;
  }

  .el-button--text {
    // color: #fff;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/workspace/views/layout/Main.vue